/** Shared snap marker colors + labels (sketch tools + move tool). */

import type { SnapKind } from '@core/geometry/snap';

export const SNAP_COLORS: Partial<Record<SnapKind, number>> = {
  endpoint: 0x6adf7e,
  midpoint: 0x5ad4d6,
  center: 0xd6a45e,
  origin: 0xe8c66a,
  'on-edge': 0xd66a5e,
  extension: 0x9aa3b2,
  parallel: 0xd65ed6,
  perpendicular: 0x8f7bff,
  'axis-x': 0xe0564e, // red — SketchUp X axis
  'axis-y': 0x4fb45f, // green — SketchUp Y axis
};

export const SNAP_LABELS: Partial<Record<SnapKind, string>> = {
  endpoint: 'Endpoint',
  midpoint: 'Midpoint',
  center: 'Center',
  origin: 'Origin',
  'on-edge': 'On edge',
  extension: 'Extension',
  parallel: 'Parallel',
  perpendicular: 'Perpendicular',
  'axis-x': 'On X axis',
  'axis-y': 'On Y axis',
};
